import { render, staticRenderFns } from "./BloodPressureAndHeartRate.vue?vue&type=template&id=31352e22&scoped=true&"
import script from "./BloodPressureAndHeartRate.vue?vue&type=script&lang=js&"
export * from "./BloodPressureAndHeartRate.vue?vue&type=script&lang=js&"
import style0 from "./BloodPressureAndHeartRate.vue?vue&type=style&index=0&id=31352e22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31352e22",
  null
  
)

export default component.exports